/* istanbul ignore file */
import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogClose } from '@angular/material/dialog';
import { ADPResourceService, ADPComponentsModule } from 'digital-core';
import { NgTemplateOutlet } from '@angular/common';
import { ModalWindowComponent } from '../modal-window/modal-window.component';
import { MatIconButton, MatButton } from '@angular/material/button';
import { AriaLabelDirective } from 'src/app/shared/directives';
import { MatIcon } from '@angular/material/icon';

@Component({
    selector: 'claims-no-devices-modal-window',
    templateUrl: './claims-no-devices-modal-window.component.html',
    styleUrls: ['./claims-no-devices-modal-window.component.scss'],
    imports: [ModalWindowComponent, MatIconButton, AriaLabelDirective, MatDialogClose, MatIcon, NgTemplateOutlet, ADPComponentsModule, MatButton]
})
export class ClaimsNoDevicesModalWindowComponent {

  constructor(
    public dialogRef: MatDialogRef<ClaimsNoDevicesModalWindowComponent>,
    @Inject(MAT_DIALOG_DATA) public modalData: any,
    private resourceService: ADPResourceService,
  ) { }

  addMyDevices() {
    //this.dialogRef.close();
    this.dialogRef.close({
      data: {
        result: 'success'
      }
    });
  }

  getLabel(key: string) {
    return this.resourceService.getViewLabel(key);
  }

  onCancelClicked() {
    this.dialogRef.close({
      data: {
        result: 'cancel'
      }
    });
  }
}
